export const FETCH_BROADCAST_VIDEOS = 'fetchBroadcastVideos';
export const FETCH_BRANDING_ASSETS = 'fetchBrandingAssets';
export const ADD_CORRECT_ANSWER = 'addCorrectAnswer';
export const ADD_WRONG_ANSWER = 'addWrongAnswer';
export const START_QUIZ = 'startQuiz';
export const BUDTENDER_LOGIN = 'budtenderLogin';
export const BUDTENDER_REGISTER = 'budtenderRegister';
export const CHECK_BUDTENDER_AUTH = 'checkBudAuth';
